import React from "react";
import { FooterStyle } from "./styled";

export const Footer = () => {
    return (
        <FooterStyle>
            Footer
        </FooterStyle>
    );
}